import React from 'react';
import { Grid, Button as MuiButton } from '@material-ui/core';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { styles } from './force-exchange-component-styles';

export const ForcedExchangeNavButtons: React.FC<ForcedExchangeNavButtonsProps> = ({
  onClickNavButtonDown,
  onClickNavButtonUp,
  navScrollDownEnabled,
  navScrollUpEnabled,
}): JSX.Element => {
  const classes = styles();

  return (
    <Grid container alignItems='center' className={`fullHeight ${classes.navBarContainer}`}>
      <Grid item xs={6}>
        <MuiButton
          style={{ float: 'right' }}
          data-testid='ej-scroll-top-button'
          onClick={onClickNavButtonUp}
          disabled={!navScrollUpEnabled}
          className={classes.arrowButtons}
        >
          <ArrowUpward />
        </MuiButton>
      </Grid>
      <Grid item xs={6}>
        <MuiButton
          style={{ float: 'left' }}
          data-testid='ej-scroll-bottom-button'
          onClick={onClickNavButtonDown}
          disabled={!navScrollDownEnabled}
          className={classes.arrowButtons}
        >
          <ArrowDownward />
        </MuiButton>
      </Grid>
    </Grid>
  );
};

interface ForcedExchangeNavButtonsProps {
  onClickNavButtonUp: () => void;
  onClickNavButtonDown: () => void;
  navScrollUpEnabled: boolean;
  navScrollDownEnabled: boolean;
}
